import { Injectable, computed, signal, effect, inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class MobileNavService {
  private _open = signal(false);
  isOpen = computed(() => this._open());

  private platformId = inject(PLATFORM_ID);

  constructor() {
    // Cerrar si pasas a desktop para evitar estados “pegados”
    if (isPlatformBrowser(this.platformId)) {
      const mq = window.matchMedia('(min-width: 1024px)');
      const handler = () => this.close();
      mq.addEventListener?.('change', handler);
    }

    // (Opcional) bloquear scroll del fondo cuando está abierto
    if (isPlatformBrowser(this.platformId)) {
      effect(() => {
        const open = this.isOpen();
        document.body.classList.toggle('nav-open', open);
      });
    }
  }

  open()  { this._open.set(true); }
  close() { this._open.set(false); }
  toggle(){ this._open.update(v => !v); }
}
